import { styled } from "@mui/material";
import { IconButton } from "@mui/material";

const StyledIconButton = styled(IconButton, {
    shouldForwardProp: (prop) => !['isActive'].includes(prop)
})(({ theme, isActive }) => ({
    width: 48,
    height: 48,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 0,
    borderRadius: 8,
    color: isActive
        ? theme.palette.primary.contrastText
        : theme.palette.secondary.contrastText,
    backgroundColor: isActive
        ? theme.palette.background.button
        : theme.palette.background.toggleButton,
    boxShadow: isActive ? theme.shadows[3] : theme.shadows[2],
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: isActive
            ? theme.palette.primary.hover
            : theme.palette.secondary.hover,
    },
    '&:active': {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.background.button,
        boxShadow: theme.shadows[3],
    },
    '& .MuiSvgIcon-root, & svg': {
        color: 'currentColor',
        transition: 'color 0.2s ease'
    }
}));

export default StyledIconButton;